import { render } from "./GenreEditor.vue?vue&type=template&id=7bb3e702"
import script from "./GenreEditor.vue?vue&type=script&lang=js"
export * from "./GenreEditor.vue?vue&type=script&lang=js"
script.render = render

export default script